export const NameSpace = {
  SEARCH: `SEARCH`,
  TRAVEL: `TRAVEL`,
  USER: `USER`,
};
